import { observer } from 'mobx-react'
import React, { FC, useState } from 'react'
import ServiceDrawerElement from '../../Drawers/CreateServiceDrawer/ServiceDrawerElement'
import WarningPaper from '../../Drawers/CreateServiceDrawer/WarningPaper'
import { searchResWarningSx } from '../consts/styles.consts'
import { createServiceRequestStore } from '../stores/NewCreateServiceRequestStore'

interface SuccessSearchResultsProps {
  results: any[]
}

const SuccessSearchResults: FC<SuccessSearchResultsProps> = ({ results }) => {
  const [resultOpenedIndex, setResultOpenedIndex] = useState(0)
  const { selectedRequest, setSelectedRequest } = createServiceRequestStore

  return (
    <>
      {results?.length > 1 && (
        <WarningPaper
          title={'Поиск дал несколько результатов'}
          text1={
            'Пожалуйста, уточните у Абонента адрес и выберите заявку с подходящими данными'
          }
          text2={null}
          style={searchResWarningSx}
        />
      )}
      {results?.map((el: any, index: number) => (
        <ServiceDrawerElement
          customOpen={undefined}
          arrowIcon={undefined}
          key={el.id}
          el={el}
          checkboxAction={() =>
            setSelectedRequest(
              el.orderId === selectedRequest?.orderId ? null : el
            )
          }
          checkedServiceOrderId={selectedRequest?.orderId}
          openedAccordionIndex={resultOpenedIndex}
          setOpenedAccordionIndex={setResultOpenedIndex}
          index={index}
          serviceStore={{}}
          leftIcon={true}
        />
      ))}
    </>
  )
}

export default observer(SuccessSearchResults)
